import { cloneDeep } from 'lodash';
import moment from 'moment';
import 'moment-timezone';

var columnSettings = {
  name: {
    class: 'tablesort-sortable',
    stSort: 'name',
    displayName: 'API_TOKENS_NAME'
  },
  datetime: {
    class: 'tablesort-sortable',
    stSort: 'usage[0].loginTime',
    displayName: 'API_TOKENS_LAST_DATE'
  },
  resource: {
    class: 'tablesort-sortable',
    stSort: 'usage[0].protectedResource',
    displayName: 'API_TOKENS_LAST_RESOURCE'
  },
  ip: {
    class: 'tablesort-sortable',
    stSort: 'usage[0].ipAddress',
    displayName: 'API_TOKENS_LAST_IP'
  },
};
 
var defaultColumns = [
  'name',
  'datetime',
  'resource',
  'ip'
];

var usageColumnSettings = {
  datetime: {
    class: 'tablesort-sortable',
    stSort: 'loginTime',
    displayName: 'DATETIME'
  },
  resource: {
    class: 'tablesort-sortable',
    stSort: 'protectedResource',
    displayName: 'RESOURCE'
  },
  ip: {
    class: 'tablesort-sortable',
    stSort: 'ipAddress',
    displayName: 'IP' 
  },
};

var usageDefaultColumns = [
  'datetime',
  'resource',
  'ip',
];
    
var defaultUsageView = {
  loginTime: '-',
  protectedResource: '-',
  ipAddress: '-'
};

export default class ApiTokensService {
/** @ngInject **/
  constructor(
    $http,
    ngAuthSettings,
    utils,
  ) {
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.utils = utils;
    this.columnSettings = cloneDeep(columnSettings);
    this.defaultColumns = cloneDeep(defaultColumns);
    this.usageColumnSettings = cloneDeep(usageColumnSettings);
    this.usageDefaultColumns = cloneDeep(usageDefaultColumns);
  } 

  getApiTokens() {
    return this.$http.get(this.#serviceBaseUrl())
      .then((resp) => {
        resp.data.apiTokens.forEach((apiToken) => {
          this.#normalizeApiToken(apiToken);
        });

        return resp;
      });
  }

  deleteApiToken(apiTokenModel) {
    return this.$http.post(this.#deleteServiceBaseUrl(), apiTokenModel);
  }

  createApiToken(apiTokenModel) {
    return this.$http.post(this.#serviceBaseUrl(), apiTokenModel);
  }

  doesItHaveUsage(apiToken) {
    return (apiToken?.usage?.length > 0);
  }

  getLastUse(apiToken) {
    if (this.doesItHaveUsage(apiToken)) {
      return apiToken.usage[0];
    }
 
    return undefined;
  }

  #normalizeApiToken(apiToken) {
    if (this.doesItHaveUsage(apiToken)) {
      apiToken.usage.forEach(usage => {
        usage = this.#normalizeApiTokenUsage(usage);
      });
    }

    var lastUsage = this.#getLastUsage(apiToken);
    apiToken.lastUsage = this.#normalizeApiTokenUsage(lastUsage);
  }

  #normalizeApiTokenUsage(apiTokenUsage) {
    if (apiTokenUsage) {
      apiTokenUsage.loginTime = moment(apiTokenUsage.loginTime).format('MMM DD, YY h:mm:ss a');

      return apiTokenUsage;
    }
 
    return defaultUsageView;
  }

  #getLastUsage(apiToken) {
    if (apiToken?.usage) {
      return apiToken.usage[0];
    }

    return {};
  }

  #serviceBaseUrl() {
    return this.ngAuthSettings.apiServiceBaseUri + 'ApiTokens';
  }

  #deleteServiceBaseUrl() {
    return this.ngAuthSettings.apiServiceBaseUri + 'ApiTokens/Delete';
  }
}